class AthletiBrandDirectory extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.input = this.querySelector('[data-brand-input]');
    if (!this.input) return;
    this.initialized = true;
    this.cards = Array.from(this.querySelectorAll('[data-brand-search]'));
    this.groups = Array.from(this.querySelectorAll('[data-brand-group]'));
    this.alphabet = this.querySelector('.athleti-alphabet');
    this.status = this.querySelector('[data-brand-status]');
    this.empty = this.querySelector('[data-brand-empty]');
    this.reset = this.querySelector('[data-brand-reset]');
    this.cards.forEach(card => {
      card.brandKey = this.normalize(card.dataset.brandSearch);
    });
    this.input.addEventListener('input', () => this.filter());
    this.reset.addEventListener('click', () => {
      this.input.value = '';
      this.filter();
      this.input.focus();
    });
    this.querySelector('[data-brand-tools]').hidden = false;
    this.filter();
  }
  normalize(value) {
    return value.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase()
      .replace(/\b1st\b/g, 'first').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  }
  filter() {
    const query = this.normalize(this.input.value);
    const words = query.split(/\s+/).filter(Boolean);
    let count = 0;
    this.cards.forEach(card => {
      const matches = words.every(word => card.brandKey.includes(word));
      card.hidden = !matches;
      if (matches) count += 1;
    });
    this.groups.forEach(group => {
      group.hidden = !Array.from(group.querySelectorAll('[data-brand-search]'))
        .some(card => !card.hidden);
    });
    this.alphabet.hidden = words.length > 0;
    this.reset.hidden = this.input.value.length === 0;
    this.empty.hidden = count > 0;
    this.status.textContent = count === 1 ? this.dataset.countOne : this.dataset.countLabel.replace('__count__', String(count));
  }
}
if (!customElements.get('athleti-brand-directory')) {
  customElements.define('athleti-brand-directory', AthletiBrandDirectory);
}
